import { render, staticRenderFns } from "./AutoAllocationConfigForm.vue?vue&type=template&id=fa458c70"
import script from "./AutoAllocationConfigForm.vue?vue&type=script&lang=js"
export * from "./AutoAllocationConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports